import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

// 避免重复导航到当前路由时报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch((err) => {
        if (err.name !== "NavigationDuplicated") throw err;
    });
};

const routes = [{
        path: "/login",
        name: "Login",
        component: () => import("@/views/login/index.vue"),
        meta: {
            title: "登录",
        },
    },
    {
        path: "/",
        component: Layout,
        redirect: "/home",
        children: [{
                path: "home",
                name: "Home",
                component: () => import("@/views/home/index.vue"),
                meta: {
                    title: "首页",
                    icon: "el-icon-s-home",
                },
            },
            // {
            //   path: 'create',
            //   name: 'Create',
            //   component: () => import('@/views/create/index.vue'),
            //   meta: { title: '开始创作', icon: 'el-icon-magic-stick' }
            // },
            {
                path: "projects",
                name: "Projects",
                component: () => import("@/views/projects/index.vue"),
                meta: {
                    title: "我的项目",
                    icon: "el-icon-folder-opened",
                },
            },

            {
                path: "detail/:id",
                name: "Detail",
                component: () => import("@/views/detail/index.vue"),
                meta: {
                    title: "作品详情",
                },
            },
            {
                path: "editor/:id",
                name: "Editor",
                component: () => import("@/views/editor/index.vue"),
                meta: {
                    title: "项目编辑",
                },
            },

            {
                path: "myAssets",
                name: "myAssets",
                component: () => import("@/views/myAssets/index.vue"),
                meta: {
                    title: "我的资产",
                    icon: "el-icon-bank-card",
                },
            },
            {
                path: "myAssets/:id",
                name: "MyAssetDetail",
                component: () => import("@/views/myAssets/detail.vue"),
                meta: {
                    title: "资产详情",
                },
            },

            {
                path: "invitation",
                name: "invitation",
                component: () => import("@/views/invitation/index.vue"),
                meta: {
                    title: "邀请有礼",
                    icon: "el-icon-present",
                },
            },
            {
                path: "revenue",
                name: "revenue",
                component: () => import("@/views/revenue/index.vue"),
                meta: {
                    title: "我的收益",
                    icon: "el-icon-money",
                },
            },
        ],
    },
];

const router = new VueRouter({
    mode: "hash",
    // base: process.env.BASE_URL,
    routes,
});

// 白名单路由，不需要登录
const whiteList = ["/login", "/", "/home"];

router.beforeEach((to, _, next) => {
    if (whiteList.includes(to.path)) {
        next();
    } else if (!localStorage.getItem("userId")) {
        next({
            path: "/login",
            replace: true,
        });
    } else {
        next();
    }
});

export default router;